var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { css, html, LitElement } from "lit";
import { customElement, property } from "lit/decorators.js";
import { classMap } from "lit/directives/class-map.js";
// TODO: come up with a better way of handling half filled states, like a mask on top of the progress unit
let ProgressUnit = class ProgressUnit extends LitElement {
    constructor() {
        super(...arguments);
        this.filled = "none";
    }
    render() {
        const classes = {
            "half-filled": this.filled !== "none",
            filled: this.filled === "filled",
        };
        return html `<div class=${classMap(classes)} id="unit">
      <div></div>
      <div></div>
    </div>`;
    }
};
ProgressUnit.styles = css `
    #unit {
      width: var(--progress-unit-width);
      height: 100%;
      display: flex;
      flex-direction: row;
    }

    #unit > div {
      width: calc(var(--progress-unit-width) / 2);
      height: 100%;
    }

    .half-filled > div:first-child {
      background: var(--progress-unit-background);
    }

    .filled > :last-child {
      background: var(--progress-unit-background);
    }
  `;
__decorate([
    property(),
    __metadata("design:type", String)
], ProgressUnit.prototype, "filled", void 0);
ProgressUnit = __decorate([
    customElement("a2k-progress-unit")
], ProgressUnit);
export { ProgressUnit };
